import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";
import Nouserimage from "../../assets/images/users/no_image.png";


const UserProfile = () => {
  //meta title
  document.title = "Profile | infuseone - Admin";
  const [name, setName] = useState();
  const [username, setUserName] = useState();
  const [email, setEmail] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [profileImage, setProfileImage] = useState();
  const [previewImage, setPreviewImage] = useState(null);
  const [getdesignation, setDesignation] = useState('');
  const [getQualification, setQualification] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [errorimage, setErrorimage] = useState(false);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    setLoading(true);
    try {
      let response = await UserService.GetUser().json();
      setName(response.data.name)
      setUserName(response.data.username)
      setEmail(response.data.email)
      setPhoneNumber(response.data.phone_number)
      setDesignation(response.data.designation);
      setQualification(response.data.qualification);
      // const imageUrl = `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`;
      const imageUrl = response.data.profile_image
        ? `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`
        : null;
      setProfileImage(imageUrl)
      setLoading(false);
      if (response.status == false) {
        setError(response.message);
        return;
      }
    } catch (error) {
      setError('something went wrong');
      return;
    }
  };


  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const fileType = file.type;
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (validImageTypes.includes(fileType)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      } else {

        setErrorimage('Please upload a valid image.');
        return;
        // alert('Please upload a valid image file.');
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const userData = {
      username: e.target.username.value,
      name: name,
      phone_number: phoneNumber,
      email: email,
      profile_image: previewImage,
      designation: e.target.designation.value,
      qualification: e.target.qualification.value
    };
    // setLoading(true);
    try {

      const response = await UserService.profileupdate(userData).json();
      if (response.status === true) {
        setError('');
        setSuccess(response.message);
        // setLoading(false);
        setErrorimage('');
        getUser();
      } else {
        // setLoading(false);
        setError(response.errors);
        return;
      }

    } catch (error) {
      setError('something went wrong');
      return;
    }
  };

  const handleNameChange = (e) => {
    const regex = /^[A-Za-z\s]*$/;
    const newValue = e.target.value;
    if (regex.test(newValue)) {
      setName(newValue);
    }
  };
  const handlePhoneNumberChange = (e) => {
    const newValue = e.target.value;
    if (/^\d{0,12}$/.test(newValue)) {
      setPhoneNumber(newValue);
    }
  };

  const handleDesignationChange = (e) => {
    const regex = /^[A-Za-z\s]*$/;
    const newValue = e.target.value;
    if (regex.test(newValue)) {
      setDesignation(newValue);
    }
  };

  const handleQualificationChange = (e) => {
    const regex = /^[A-Za-z\s]*$/;
    const newValue = e.target.value;
    if (regex.test(newValue)) {
      setQualification(newValue);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Dashboard" breadcrumbItem="Profile" />
          {isLoading ? <Spinners setLoading={setLoading} /> :
            <>
              <Row>
                <Col lg="12">

                  <Card className="commonboxform">
                    <CardBody>
                      <div className="d-flex">
                        <div className="ms-3 mx-3">
                          <img
                            src={profileImage ? profileImage : Nouserimage}
                            alt=""
                            className="avatar-md rounded-circle img-thumbnail"
                          />
                        </div>
                        <div className="flex-grow-1 align-self-center">
                          <div className="text-muted">
                            <h5>{name}</h5>
                            <p className="mb-1">{email}</p>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <h4 className="card-title mb-4">Update Profile</h4>

              <Card className="commonboxform">
                <CardBody>
                  {success && (
                    <Alert color="success" style={{ marginTop: "13px" }}>
                      {success}
                    </Alert>
                  )}


                  <Form
                    className="form-horizontal"
                    onSubmit={handleSubmit}
                  >
                    <div className="form-group">
                      <div className="mb-3">
                        <Label className="form-label">Username <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                        <Input
                          name="username"
                          className="form-control"
                          placeholder="Enter Username"
                          type="text"
                          defaultValue={username}
                        />
                        {error.username && (
                          <FormFeedback type="invalid" style={{ display: 'block' }}>{error.username}</FormFeedback>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Name <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                        <Input
                          name="Name"
                          className="form-control"
                          placeholder="Enter Name"
                          type="text"
                          value={name}
                          onChange={handleNameChange}
                        />
                        {error.name && (
                          <FormFeedback type="invalid" style={{ display: 'block' }}>{error.name}</FormFeedback>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Email <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Email"
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        {error.email && (
                          <FormFeedback type="invalid" style={{ display: 'block' }}>{error.email}</FormFeedback>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Phone Number</Label>
                        <Input
                          name="phonenumber"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          type="text"
                          value={phoneNumber}
                          onChange={handlePhoneNumberChange}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Designation</Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="designation"
                          name="designation"
                          placeholder="Enter Designation"
                          value={getdesignation}
                          onChange={handleDesignationChange}
                        />
                        {error.designation && (
                          <FormFeedback type="invalid" style={{ display: 'block' }}>{error.designation[0]}</FormFeedback>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Qualification</Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="qualification"
                          name="qualification"
                          placeholder="Enter Qualification"
                          value={getQualification}
                          onChange={handleQualificationChange}
                        />
                        {error.qualification && (
                          <FormFeedback type="invalid" style={{ display: 'block' }}>{error.qualification[0]}</FormFeedback>
                        )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Profile Image</Label>
                        {previewImage ? (
                          <div className="mb-3 text-left">
                            <img
                              src={previewImage}
                              alt="Profile Preview"
                              className="img-fluid rounded-circle"
                              style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                            />
                          </div>
                        ) : (
                          <div className="mb-3 text-left">
                            <img
                              src={profileImage ? profileImage : Nouserimage}
                              alt="Profile"
                              className="img-fluid rounded-circle"
                              style={{ width: '100px', height: '100px', objectFit: 'cover' }}

                            />
                          </div>
                        )}
                        <Input
                          type="file"
                          className="form-control"
                          id="profileImage"
                          onChange={handleImageChange}
                        />
                      </div>

                      {errorimage && (
                        <FormFeedback type="invalid" style={{ display: 'block' }}>{errorimage}</FormFeedback>
                      )}
                    </div>
                    <div className="text-left mt-4">
                      <Button type="submit" color="secondary">
                        Update
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </>
          }
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
